// extracted by mini-css-extract-plugin
module.exports = {"label":"TableCellMobile_label__qoXVV","value":"TableCellMobile_value___w759","card":"TableCellMobile_card__25RO1"};